export default __webpack_public_path__ + "static/main-270a6041945c0fea8259541552079f62.jpeg";